module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (Object.keys(_vm.componentType).length > 0) ? _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "brand",
    staticClass: "modal-mask",
    attrs: {
      "id": "brand"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent"
  }, [_c('h1', {
    staticClass: "uppercase productShadeTitle"
  }, [_vm._v(_vm._s(_vm.componentType.name))]), _vm._v(" "), _c('form', {
    staticClass: "form_campaing",
    attrs: {
      "enctype": "multipart/form-data",
      "action": ""
    }
  }, [_c('table', [_c('tr', [_c('td', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom")])]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentType.name),
      expression: "componentType.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.componentType.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.componentType.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom EN")])]), _vm._v(" "), (_vm.componentType.terms.hasOwnProperty('name')) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentType.terms.name['en']['value']),
      expression: "componentType.terms.name['en']['value']"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.componentType.terms.name['en']['value'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.componentType.terms.name['en'], 'value', $event.target.value)
      }
    }
  })]) : _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameEN),
      expression: "nameEN"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nameEN)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameEN = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Nom FR")])]), _vm._v(" "), (_vm.componentType.terms.hasOwnProperty('name')) ? _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.componentType.terms.name['fr']['value']),
      expression: "componentType.terms.name['fr']['value']"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.componentType.terms.name['fr']['value'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.componentType.terms.name['fr'], 'value', $event.target.value)
      }
    }
  })]) : _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameFR),
      expression: "nameFR"
    }],
    staticClass: "input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nameFR)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameFR = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flexContainer boutonSaveDelete"
  }, [_c('button', {
    staticClass: "btn block pointer uppercase save",
    on: {
      "click": function($event) {
        _vm.saveEditBrand();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("zone.save")))]), _vm._v(" "), _c('button', {
    staticClass: "btn block pointer uppercase save",
    on: {
      "click": function($event) {
        _vm.closeModal();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))])])])])])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f3c9b4a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/componentType/EditComponentType.vue
// module id = 3311
// module chunks = 0